import React from 'react';
import { TabbedOverviewPage } from '../components/OverviewSections.comp';
import AboutRubricsTab from '../tabs/AboutRubrics.tab';

const MethodologyPage = () => (
    <TabbedOverviewPage
        skipNoDataGate
        tabs={[
            {
                label: 'How the Assessment Is Scored',
                content: <AboutRubricsTab />,
            },
        ]}
    />
);

export default MethodologyPage;
